import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        open: Boolean
    }

    connect() {
        this.drawer = bootstrap.Drawer.getOrCreateInstance(this.element)
        this.beforeCache = () => this.drawer.hide()
        document.addEventListener("turbo:before-cache", this.beforeCache)

        if (this.openValue) {
            requestAnimationFrame(() => this.drawer.show())
        }
    }

    disconnect() {
        document.removeEventListener("turbo:before-cache", this.beforeCache)
        this.drawer?.dispose()
    }
}
